import { OneColumn } from 'components/page';
import { ClusterGrid, ClusterGridFilter } from 'pages/complementar/cluster/components';

export function ClusterListComp() {
    return (
        <OneColumn title="Clusters" createButton>
            <ClusterGridFilter />

            <ClusterGrid />
        </OneColumn>
    );
}
